<div class="route-component">
    <wizard-control #wizard (onFinished)="finished()">

        <wizard-step title="Select Rows" [valid]="isRowSelectionValid()" [wizardStepInstance]="rowSelectionComponent">
            <claim-data-range-selection #rowSelectionComponent />
        </wizard-step>

        <wizard-step title="Map Columns"  [valid]="isColumnSelectionValid()" [wizardStepInstance]="columnSelectionComponent">
            <claim-data-column-selection   #columnSelectionComponent/>
        </wizard-step>

        <wizard-step title="Import" [valid]="isImportValid()" [wizardStepInstance]="importComponent">
            <claim-data-import-data #importComponent />
        </wizard-step>

        <wizard-step title="Summary">
            <h4>
                Done!
            </h4>
            <p>
                Batch imported successfully, click Finish to mark as Complete
            </p>
        </wizard-step>

    </wizard-control>
</div>